import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { Sandbox } from '@/models/sandbox';

export const sandboxQueryKey = {
  all: ['sandbox'] as const,
};

export const getSandbox = async ({ sandboxId }: { sandboxId: string }) => {
  const response = await api.get<Sandbox>(`/v1/sandbox/${sandboxId}`);
  return response.data;
};

export const getSandboxQueryOptions = ({
  sandboxId,
}: {
  sandboxId: string;
}) => ({
  queryKey: [...sandboxQueryKey.all, sandboxId],
  queryFn: () => getSandbox({ sandboxId }),
  enabled: !!sandboxId,
});

export const useGetSandbox = (
  { sandboxId }: { sandboxId: string },
  options?: { enabled?: boolean },
) => {
  return useQuery({
    ...getSandboxQueryOptions({ sandboxId }),
    ...options,
  });
};
